import { render, staticRenderFns } from "./Userform.vue?vue&type=template&id=022dd93c&"
import script from "./Userform.vue?vue&type=script&lang=js&"
export * from "./Userform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports